import { SAVE_XERO_ACCOUNTS } from '../../../../../../constants/constant_xero';

export function showXeroAccountModal() {
  return { type: 'SHOW_XERO_ACCOUNT_MODAL' };
}

export function hideXeroAccountModal() {
  return { type: 'HIDE_XERO_ACCOUNT_MODAL' };
}

export function resetXeroAccountModal() {
  return { type: 'RESET_XERO_ACCOUNT_MODAL' };
}

export function setDataXeroAccountModal(data) {
  return { type: 'SET_DATA_XERO_ACCOUNT_MODAL', payload: data };
}

export function setInfoXeroAccountModal(infos) {
  return { type: 'SET_INFO_XERO_ACCOUNT_MODAL', payload: infos };
}

export function clearInfoXeroAccountModal() {
  return { type: 'SET_INFO_XERO_ACCOUNT_MODAL' };
}

export function setErrorXeroAccountModal(errors) {
  if (errors.meta) {
    const payload = errors.meta.errors.map((m) => ({ message: m.Message }));
    return { type: 'SET_ERROR_XERO_ACCOUNT_MODAL', payload };
  }

  return { type: 'SET_ERROR_XERO_ACCOUNT_MODAL', payload: errors };
}

export function clearErrorXeroAccountModal() {
  return { type: 'CLEAR_ERROR_XERO_ACCOUNT_MODAL' };
}

export function saveXeroAccount(integrationId, data) {
  return { type: SAVE_XERO_ACCOUNTS, integrationId, data };
}
